module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('em', [_vm._v("the")]), _c('br'), _vm._v("Tantric Sex"), _c('br'), _c('em', [_vm._v("deck")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("50 Paths to Sacred Sex and Lasting Love")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("by Don and Debra Macleod")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("*")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('em', [_vm._v("Mystical Sex vs. Modern Sex")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At first glance, Tantric sex may seem too esoteric and inaccessible to be useful. After all, we’re a techno-quickie culture and such an ancient, time-consuming, and obscure sexual art couldn’t have anything to offer today’s busy couple—or could it?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In public, sex is everywhere. It’s on billboards, TV, the Internet. . . you name it. Yet in private, many couples suffer a lack of sexual fulfillment, often buying into the quick fix, be it medication, the latest sex toy, or a designer weekend “retreat.” But quick fixes always break, and while popular culture gets rich by selling this kind of fast-food sex, couples are clearly in need of something more nourishing.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Emerging from the ancient East, Tantric sex has been embraced by some in the modern Western world as a way to nourish the intimate bond between a couple on all levels, including physical, emotional, sexual, and spiritual. During Tantric sex, lovers harness sexual energy to merge not only with each other’s bodies and beings, but also with the divine cosmic consciousness. Every moment of sexual contact is ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("considered orgasmic, not just the final release, and lovers bask in each ecstatic moment of togetherness.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("With all the stresses and disconnections facing the modern couple, Tantric sexual practices are perhaps more relevant today than ever. So forget the fast-food fixes and try a taste of Tantra instead. It just may be your path to spiritual joy, sexual bliss, and lasting love.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("*")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("What’s Inside")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first five cards in "), _c('em', [_vm._v("The Tantric Sex Deck")]), _vm._v(" are theory cards: These lay the foundation for the understanding and performance of Tantric sex. The remaining forty-five cards are Tantric sex technique cards: These outline everything from sensual cleansing rituals and erotic exercises to explicit oral-sex techniques and exciting sexual positions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The path to the crown jewel of Tantric sex—the coveted male multi-orgasmic experience—is also illuminated in full, glorious detail. No, it isn’t a mythical creature. It’s a real technique that any man can master to pleasure himself and his woman like never before. Your sex life will be, quite literally, transformed.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('em', [_vm._v("Using the Cards")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "textcenter1"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before a couple can welcome Tantric sex into their love life, they must be aware of what it is they’re trying to achieve. It is therefore essential to spend a few moments reading about theory before moving on to technique. In the theory cards, we’ve highlighted a few key elements of Tantric sex without saddling you with excessive study.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The technique cards should initially be read in order, from #6 to #50; however, as you become more adept at Tantric sex, you may wish to shuffle the deck and surprise yourselves with a different technique to practice each night, week, or even month. In this way, "), _c('em', [_vm._v("The")]), _vm._v(" "), _c('em', [_vm._v("Tantric Sex Deck")]), _vm._v(" will become a valuable sexual resource that you and your lover can tap into again and again. For when it comes to Tantric sex, practice truly does make perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Precautions: When practiced properly, Tantric sex can enrich a couple’s sex life; however, like any physical activity, participants must tailor it to their individual abilities and life circumstances. If you have concerns about performing any of the techniques in this deck, consult your doctor first, or simply skip the card in question. You know your body best, so listen to it. And if you aren’t in a fluid-bonded, monogamous relationship where you’re aware of each other’s sexual health, always practice safe sex.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73736436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 60
// module chunks = 0